import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";
import { ClubEvent, ClubEventList } from "@/models";

const state = {
  clubEvent: new ClubEvent(),
  clubListEvent: new ClubEventList(),
  clubEvents: [],
  clubListEvents: [],
  clubEventLoading: false,
  clubEventsLoading: false,
  meta: {},
  clubEventsLimited: [],
  clubEventsLimitedV1:[],
  currentPage: 1,
  messagePageLoading: false
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
};
